import TextField from './LqVTextField'
export default TextField.extend({
    name: 'lq-v-rating',
    data () {
        return {
            tagName: 'v-rating'
        }
    }
})